import React from 'react';
import { ShieldAlert, Activity, Bug, Search, Zap, ShieldCheck } from 'lucide-react';
import './SecurityCompliance.css';

const MalwareProtection = () => {
  return (
    <div className="security-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <div className="status-badge">
              <Activity size={14} /> System Scanned: Healthy
            </div>
            <h1>Advanced Malware Detection & Neutralization</h1>
            <p>
              Proactive threat hunting and automated malware removal to keep your 
              digital ecosystem clean and operational 24/7.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Scan My System</a>
              <a className="button secondary" href="#features">How it works</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-gradient">
              <ShieldAlert className="icon" size={48} />
              <h3>Threat Intelligence</h3>
              <p>Real-time updates on global vulnerability databases to block zero-day exploits.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="section">
        <div className="section-heading">
          <span className="eyebrow">Prevention First</span>
          <h2>The shield against digital infection.</h2>
          <p>We deploy multi-layered security protocols that monitor, identify, and eliminate malicious scripts before they execute.</p>
        </div>

        <div className="security-grid">
          <div className="security-card">
            <div className="sec-icon"><Search size={24} /></div>
            <h3>Deep Core Scanning</h3>
            <p>Continuous scanning of server files, databases, and configuration files for anomalous patterns.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><Zap size={24} /></div>
            <h3>Auto-Healing</h3>
            <p>Instant replacement of infected files with clean, verified backups the moment a threat is detected.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><Bug size={24} /></div>
            <h3>Bot Mitigation</h3>
            <p>Advanced filtering of brute-force attacks and malicious scrapers via global firewall rules.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="feature-block">
          <div className="encryption-visual">
             <Activity className="lock-animation" size={80} color="#10b981" />
          </div>
          <div className="solution-copy">
            <h3>Enterprise Security Monitoring</h3>
            <p>
              Our centralized dashboard gives you a bird's-eye view of your entire 
              infrastructure security status, with instant alerts via Slack or Email.
            </p>
            <ul className="feature-list-alt">
              <li className="feature-item-alt">
                <ShieldCheck size={20} className="sec-icon-inline" />
                <div>
                  <h4>Zero-Payload Latency</h4>
                  <p>Our security layers run without impacting your website loading speed.</p>
                </div>
              </li>
              <li className="feature-item-alt">
                <ShieldCheck size={20} className="sec-icon-inline" />
                <div>
                  <h4>Quarantine Protocol</h4>
                  <p>Suspicious files are isolated automatically for manual expert review.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Infected website?</h2>
          <p>We specialize in emergency malware removal and site recovery. Get back online safely.</p>
          <a className="button primary" href="#contact">Contact Security Desk</a>
        </div>
      </section>
    </div>
  );
};

export default MalwareProtection;
